module.exports = __webpack_public_path__ + "static/media/logo_footer.1e52ae19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_footer.png
// module id = 755
// module chunks = 0